

import xfans_header from '@/components/xfans_header.vue';
import xfans_footer from '@/components/xfans_footer.vue';
export default {
    components: { xfans_header, xfans_footer },
    data() {
        return {
            flag: true,
            iFrameCode: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WWLFN42G"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`
        };
    },
    created() {
        this.updateLayoutVisible()
    },
    mounted() {
        window.addEventListener("beforeunload", (e) => { this.removeVerify() });
        window.addEventListener("unload", (e) => { this.removeVerify() });
    },
    watch: {
        '$route.name'() {
            this.updateLayoutVisible()
        }
    },
    methods: {
        updateLayoutVisible() {
            if (!process.client) return

            const routeName = this.$route?.name || ''
            const hideOnMobileRoutes = [
                routeName.includes('events-'),
                routeName.includes('document-'),
                routeName.startsWith('app-'),
                routeName === 'xcoins-xcoinRules',
                routeName === 'xcoins-xcoinTerms',
            ]
            const userAgent = navigator.userAgent
            const touchPoints = navigator.maxTouchPoints || 0
            const isTouchDevice = touchPoints > 1 || 'ontouchstart' in window
            const viewportWidth = Math.min(window.innerWidth || 0, window.screen?.width || window.innerWidth || 0)
            const isIPadOS = /Macintosh/i.test(userAgent) && isTouchDevice
            const isPadViewport = isTouchDevice && viewportWidth >= 768 && viewportWidth <= 1366
            const isMobile = isIPadOS || isPadViewport || /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(userAgent)

            this.flag = !(hideOnMobileRoutes.some(Boolean) && isMobile)
        },
        removeVerify() {
            this.$cookies.remove("verifyReleaseWork")
            this.$cookies.remove("verifyMaterial")
            this.$cookies.remove("verifyComment")
            this.$cookies.remove("verifyReleaseDiscussion")

        }
    }






}
